import { Icons, Link, SvgSpriteConsumer } from '@pluxee-design-system/core';
import { ComponentProps } from 'components/VirtualizedTable/types';
import { Location } from 'generated/models';
import NextLink from 'next/link';
import { useCallback } from 'react';
import gtm from 'trackers/gtm';

const DetailsCell = ({ index, row: { uid, name } }: ComponentProps<Location>) => {
  const trackClick = useCallback(() => {
    gtm.trackClickLocationsDetails(uid, name, index);
  }, [index, name, uid]);

  return (
    <Link
      as={NextLink}
      href={`/locations/${uid}`}
      onClick={trackClick}
      prefetch={false}
      variant="primary"
    >
      <SvgSpriteConsumer size={24} svgId={Icons.THREE_DOTS_VERTICAL24} />
    </Link>
  );
};

export default DetailsCell;
